import {
    type TextStyle,
    StyleSheet
} from "react-native";
import {
    type InputGroupTextAreaSubmitConstantType,
    type InputGroupTextAreaDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getInputTextStyle
} from "../../../../helpers/theme/input";
import {
    webStyle
} from "../../../../utils";

export const getInputGroupTextAreaIsSubmit = ({
    submitBehaviour,
    event
}: InputGroupTextAreaSubmitConstantType): boolean => {
    if(submitBehaviour === "none" || event.key !== "Enter" || event.isComposing) {
        return false;
    }

    const isModifierPressed = !!event.metaKey || !!event.ctrlKey;

    if(submitBehaviour === "modEnter") {
        return isModifierPressed;
    }

    return !event.shiftKey;
};

const stylesheet = StyleSheet.create({
    input: {
        backgroundColor: "transparent",
        includeFontPadding: false,
        textAlignVertical: "top",
        alignSelf: "stretch",
        paddingBottom: 0,
        borderWidth: 0,
        minWidth: 0,
        margin: 0,
        flex: 1,
        ...webStyle({
            fieldSizing: "content"
        })
    }
});

export const useStyles = ({
    contentHeight,
    currentSize,
    pointerType,
    typography,
    maxRows,
    minRows,
    spaces
}: InputGroupTextAreaDynamicStyleType) => {
    const lineHeight = typography[currentSize.valueVariant].lineHeight;

    const styles = {
        input: {
            ...getInputTextStyle({
                textStyle: typography[currentSize.valueVariant],
                pointerType,
                typography
            }),
            maxHeight: lineHeight * maxRows + spaces.spacingSm,
            minHeight: lineHeight * minRows + spaces.spacingSm,
            paddingHorizontal: currentSize.paddingHorizontal,
            paddingTop: spaces.spacingSm
        } as Mutable<TextStyle>
    };

    if(contentHeight !== undefined) {
        styles.input.height = contentHeight;
    }

    return styles;
};
export default stylesheet;
